import { MenuOptions } from './MenuOptions';
import ic_kidiLogo from '/icons/ic_kidi_logo.svg?raw'

export function CreateLogoOptions(container: TSelection<"div">) {
    let menuOptions: MenuOptions = null;
    const btnMenu = container.append("div").classed("main-options", true)
        .on("click", () => {
            if (menuOptions) {
                menuOptions._Destroy();
                menuOptions = null;
            } else {
                menuOptions = new MenuOptions();
                menuOptions._OnDestroyCallback = () => {
                    menuOptions = null;
                    btnMenu.classed("active", !!menuOptions);
                };
            }
            btnMenu.classed("active", !!menuOptions);
        })

    btnMenu.html(ic_kidiLogo)
        .select("svg")
        .attr("class", "img-logo-options");
}